// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2x_xu","rightAdornment":"Header_rightAdornment__2JR1D"};